import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function About() {
  useEffect(() => {
    document.title = `About the brand | ${siteConfig.displayName}`;
  }, []);

  const collageProducts = ["Coats & jackets", "Sweaters & cardigans", "T-shirts & sweatshirts", "Bags"]
    .map((category) => productData.find((product) => product.category === category))
    .filter(Boolean);
  const ctaProduct = productData.find((product) => product.category === "Dresses") || productData[0];

  return (
    <main className="about-page">
      <section className="about-hero">
        <img
          src="/img/generated/product-23-view-06.jpg"
          alt="Colorful tailoring in a contemporary gallery"
          fetchpriority="high"
        />
      </section>

      <section className="about-intro">
        <p className="eyebrow">ABOUT THE BRAND</p>
        <h1>Color with confidence.<br />Style made personal.</h1>
        <p>
          Guided by an instinct for color and a belief that clothes should lift
          your spirits, {siteConfig.displayName} brings expressive tailoring and
          accessories together with a playful point of view.
        </p>
      </section>

      <section className="about-collage" aria-label="Brand universe">
        <figure className="about-collage__portrait about-collage__portrait--one">
          <img src="/img/generated/product-02-view-06.jpg" alt="Bold seasonal color story" loading="lazy" />
          <figcaption>Fierce, fabulous and full of feeling.</figcaption>
        </figure>
        <figure className="about-collage__landscape">
          <img src="/img/generated/product-21-view-04.jpg" alt="Cobalt editorial styling" loading="lazy" />
          <figcaption>Unexpected color is our neutral.</figcaption>
        </figure>
      </section>

      <blockquote>
        “We make clothes for people who dress with optimism — pieces with
        enough confidence to start a conversation.”
      </blockquote>

      <section className="about-product-collage">
        {collageProducts.map(
          (product, index) => (
            <figure key={product.id} className={`about-shot about-shot--${index + 1}`}>
              <img src={product.images[index + 2]} alt={product.name} loading="lazy" />
              <figcaption>{["Print", "Craft", "Joy", "Form"][index]}</figcaption>
            </figure>
          )
        )}
      </section>

      <section className="about-values" id="values">
        <header>
          <p className="eyebrow">OUR POINT OF VIEW</p>
          <h2>Serious craft.<br />Never too serious.</h2>
        </header>
        <div>
          <article>
            <span>01</span>
            <h3>Designed to last</h3>
            <p>Considered silhouettes, honest materials and details worth looking at twice.</p>
          </article>
          <article>
            <span>02</span>
            <h3>Color is energy</h3>
            <p>Our palettes pair unlikely shades to make getting dressed feel instinctive again.</p>
          </article>
          <article>
            <span>03</span>
            <h3>People first</h3>
            <p>We design for real movement, real personalities and the pleasure of self-expression.</p>
          </article>
        </div>
      </section>

      <section className="about-cta">
        <img src={ctaProduct.images[5]} alt={ctaProduct.name} loading="lazy" />
        <div>
          <h2>Meet the new collection</h2>
          <Link className="button" to="/shop?sort=new">Shop now</Link>
        </div>
      </section>
    </main>
  );
}

export default About;
